import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import {
  SelectWrapper,
  StyledLabel,
  StyledSelect,
  ErrorText,
} from "./Select.styles";
import { SelectProps } from "../../../interfaces";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, options, ...props }, ref) => {
    const { t } = useTranslation();
    return (
      <SelectWrapper>
        {label && <StyledLabel>{label}</StyledLabel>}
        <StyledSelect ref={ref} $hasError={!!error} {...props}>
          <option value="" disabled>
            {t("common:select_option")}
          </option>

          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </StyledSelect>
        {error && <ErrorText>{error}</ErrorText>}
      </SelectWrapper>
    );
  },
);

Select.displayName = "Select";
